import { render } from "./tpl_title.vue?vue&type=template&id=0e95c157&scoped=true"
import script from "./tpl_title.vue?vue&type=script&lang=js"
export * from "./tpl_title.vue?vue&type=script&lang=js"

import "./tpl_title.vue?vue&type=style&index=0&id=0e95c157&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e95c157"],['__file',"src/views/wap/template/tpl_title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e95c157"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e95c157', __exports__)) {
    console.log('reload')
    api.reload('0e95c157', __exports__)
  }
  
  module.hot.accept("./tpl_title.vue?vue&type=template&id=0e95c157&scoped=true", () => {
    console.log('re-render')
    api.rerender('0e95c157', render)
  })

}


export default __exports__